<template>
  <div class="profile__card">
    <h4 class="profile__title">Editar dados profissionais</h4>

    <p v-show="hasUpdated" class="success-form-msg">
      Dados atualizados com sucesso!
      <BIconX @click="onCloseSuccessMessage" />
    </p>

    <form class="profile__form">
      <div class="profile__form-group">
        <div class="custom-form-control">
          <label>Conselho</label>
          <select class="custom-select form-control" @change="onSetCouncil">
            <option
              v-for="(council, index) in filteredConcils"
              :key="index"
              :value="council.id"
              :selected="doctor_property.council_name == council.name"
            >
              {{ council.name }}
            </option>
          </select>
        </div>

        <div class="custom-form-control">
          <label>Especialidade</label>
          <select
            class="custom-select form-control"
            @change="onSetMedicalSpecialty"
          >
            <option
              v-for="(speciality, index) in filteredSpecialities"
              :key="index"
              :value="speciality.id"
              :selected="
                doctor_property.medical_specialty_name == speciality.name
              "
            >
              {{ speciality.name }}
            </option>
          </select>
        </div>

        <div class="custom-form-control">
          <label>UF do conselho</label>
          <select class="custom-select form-control" @change="onSetCouncilUF">
            <option
              v-for="(uf, uf_index) in ufs"
              :key="uf_index"
              :value="uf"
              :selected="doctor_property.council_uf == uf"
            >
              {{ uf }}
            </option>
          </select>
        </div>

        <div class="custom-form-control">
          <label>Valor da consulta</label>
          <input
            class="form-control"
            :class="[
              $v.doctor_property.price_cents.$error
                ? 'form-control-invalid'
                : ''
            ]"
            v-mask="['R$ ##', 'R$ ###', 'R$ ####']"
            v-model="doctor_property.price_cents"
          />
          <div v-if="$v.doctor_property.price_cents.$error">
            <p class="error" v-if="!$v.doctor_property.price_cents.required">
              Campo obrigatório
            </p>
          </div>
        </div>
      </div>

      <button
        class="button3"
        :class="[disableUpdateButton ? 'disable' : '']"
        :disabled="disableUpdateButton"
        @click.prevent="updateDoctorData"
      >
        Salvar alterações
      </button>
    </form>
  </div>
</template>

<script>
import {
  userComputed,
  doctorMethods,
  councilMethods,
  specialityMethods
} from "../state/helpers";
import { required, maxLength } from "vuelidate/lib/validators";

export default {
  name: "DoctorPropertyForm",
  data() {
    return {
      doctor_property: {},
      hasUpdated: false,
      loading: false,
      ufs: [
        "AC",
        "AL",
        "AP",
        "AM",
        "BA",
        "CE",
        "DF",
        "ES",
        "GO",
        "MA",
        "MT",
        "MS",
        "MG",
        "PA",
        "PB",
        "PR",
        "PE",
        "PI",
        "RJ",
        "RN",
        "RS",
        "RO",
        "RR",
        "SC",
        "SP",
        "SE",
        "TO"
      ],
    };
  },
  validations: {
    doctor_property: {
      price_cents: { required },
      council_name: { required },
      medical_specialty_name: { required }
    }
  },
  async mounted() {
    await this.fetchAllSpecialities();
    await this.fetchAllCouncils();
    let doctor = Object.assign({}, this.currentUser.doctor_property);

    this.doctor_property = doctor;
  },
  methods: {
    ...doctorMethods,
    ...councilMethods,
    ...specialityMethods,
    onSetCouncilUF($event) {
      this.doctor_property.council_uf = $event.target.value;
    },
    onSetCouncil($event) {
      this.doctor_property.council_id = $event.target.value;
      this.$store.state.council.councils.filter(item => {
        if (item.id == $event.target.value) {
          this.doctor_property.council_name = item.name;
        }
      });
    },
    onSetMedicalSpecialty($event) {
      this.doctor_property.medical_specialty_id = $event.target.value;
      this.$store.state.speciality.specialities.filter(item => {
        if (item.id == $event.target.value) {
          this.doctor_property.medical_specialty_name = item.name;
        }
      });
    },
    async updateDoctorData() {
      const payload = Object.assign({}, this.doctor_property);
      this.loading = true;

      await this.updateDoctorProperties(payload);

      this.hasUpdated = true;
      this.loading = false;
    },
    onCloseSuccessMessage() {
      this.hasUpdated = false;
    }
  },
  computed: {
    ...userComputed,
    filteredConcils() {
      return this.$store.state.council.councils;
    },
    filteredSpecialities() {
      return this.$store.state.speciality.specialities;
    },
    disableUpdateButton() {
      return this.loading || this.$v.doctor_property.$invalid;
    }
  }
};
</script>
